<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称">
                <el-input v-model="addProductInfo.prodName" placeholder="必填，请填写商品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品分组">
                <el-select v-model="addProductInfo.categoryId" style="width:100%">
                  <el-option label="必填，请选择商品分组" value="" disabled></el-option>
                  <el-option v-for="(item, index) in addProductInfo.productCategorys" :key="index"
                    :label="formatCategoryOptionLabel(item)" :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位">
                <el-input v-model="addProductInfo.unitName" placeholder="选填，请填写单位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序">
                <el-input v-model="addProductInfo.sort" placeholder="必填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关键词">
                <el-input v-model="addProductInfo.keyword" placeholder="必填，请填写关键词,多个关键词用;分隔">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="手机菜单">
                <el-checkbox-group v-model="addProductInfo.hktIds">
                  <el-checkbox v-for="(item, index) in addProductInfo.housekeepingTypes" :key="index"
                    :label="item.hktId">
                    {{ item.hktName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="仓库">
                <el-select v-model="addProductInfo.shId" @change="_changeShopHouseAdd(addProductInfo.shId)"
                  style="width:100%">
                  <el-option label="请选择仓库" value="" disabled></el-option>
                  <el-option v-for="(item, index) in addProductInfo.shopHouses" :key="index" :label="item.shName"
                    :value="item.shId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="库存警告数量">
                <el-input-number v-model="addProductInfo.warnStock" placeholder="必填，请填写库存警告数量">
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品简介">
                <el-input type="textarea" :rows="3" v-model="addProductInfo.prodDesc" placeholder="必填，请填写商品简介"
                  maxlength="250">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品图片</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品封面">
                <upload-image-url ref="coverImageUpload" :image-count="1"
                  @notifyUploadCoverImage="handleCoverImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品轮播">
                <upload-image-url ref="carouselImageUpload" :image-count="3"
                  @notifyUploadCoverImage="handleCarouselImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" style="float:right" @click="_openAddSpecModal()">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="addProductInfo.productSpecs" border style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specName" placeholder="请输入规格名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.stock"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.sales"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格/积分" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.price"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.costPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="ownerPrice" label="业主价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.ownerPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="vipPrice" label="会员价格" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.vipPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="otPrice" label="市场价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.otPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="deduction" label="抵扣金" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.deduction"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.barCode"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="_openAddDeleteProductSpec(scope.row)">
                删除
              </el-button>
              <el-button v-if="scope.row.isDefault != 'T'" type="primary" size="mini"
                @click="_doAddDefaultProductSpec(addProductInfo, scope.row)">
                默认规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px;">
          <span>抵扣金：商品购买时抵扣金会自动送客户用来 缴相应的物业费停车费</span>
        </div>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品扩展</span>
      </div>
      <div class="">
        <el-form label-width="180px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品状态">
                <el-select v-model="addProductInfo.state" style="width:100%">
                  <el-option label="选填，请选择状态" value="" disabled></el-option>
                  <el-option label="未上架" value="1001"></el-option>
                  <el-option label="上架" value="2002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="同步时商品自动上下架">
                <el-radio-group v-model="addProductInfo.syncAutoShelfOn">
                  <el-radio :label="true">开启</el-radio>
                  <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
                <div class="form-tip">
                  开启后允许第三方同步库存时根据库存自动修改上下架；关闭后将锁定上下架状态，同步时不再自动修改上下架。
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品详情">
                <RichTextEditor v-model="addProductInfo.content"  @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="_closeAddProduct()">
            取消
          </el-button>
          <el-button type="primary" @click="saveProductInfo()">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
//import TinymceEditor from '@/components/TinymceEditor'
import RichTextEditor from '@/components/system/RichTextEditor.vue'

import { getDict } from '@/api/shop/shopApi'
import { getShopId,getAreaCode } from '@/api/shop/shopApi'
import { saveProduct, queryProductCategory, queryHousekeepingType, queryShopHouse } from '@/api/goods/productApi'

export default {
  name: 'AddProduct',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      addProductInfo: {
        shId: '',
        shName: '',
        warnStock: '',
        productId: '',
        categoryId: '',
        prodName: '',
        prodDesc: '',
        keyword: '',
        barCode: '1',
        unitName: '',
        sort: '',
        isPostage: '2',
        postage: '0.00',
        productCategorys: [],
        content: '',
        states: [],
        state: '',
        syncAutoShelfOn: true,
        coverPhoto: '',
        carouselFigurePhoto: [],
        productSpecs: [],
        areaCode: '',
        distributionModes: [],
        hktIds: [],
        housekeepingTypes: [],
        shopHouses: []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.initData()
  },
  methods: {
    async initData() {
      try {
        // 获取字典数据
        const { data: dictData } = await getDict('product', 'state')
        this.addProductInfo.states = dictData

        // 初始化商品数据
        this._initAddProduct()

        // 获取仓库列表
        this._listShopHouses()

        // 获取家政类型
        this._listAddHousekeepingTypes()

        // 获取商品分类
        this._listAddProductCategorys()
      } catch (error) {
        console.error('初始化数据失败:', error)
      }
    },

    handleCoverImageUpload(param) {
      if (param.length > 0) {
        this.addProductInfo.coverPhoto = param[0]
      } else {
        this.addProductInfo.coverPhoto = ''
      }
    },

    handleCarouselImageUpload(param) {
      this.addProductInfo.carouselFigurePhoto = []
      param.forEach(p => {
        this.addProductInfo.carouselFigurePhoto.push(p)
      })
    },

    addProductValidate() {
      // 验证逻辑保持不变
      // ...
      return true
    },
    handleContentChange(content) {
      this.addProductInfo.content = content
    },

    async saveProductInfo() {
      try {
        const flag = this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
        if (!flag && this.addProductInfo.productSpecs.length > 0) {
          this.$message.warning('未选择默认规格')
          return
        }

        if (!this.addProductValidate()) {
          //this.$message.warning(this.validate.errInfo)
          return
        }

        this.addProductInfo.shopId = this.shopId
        this.addProductInfo.areaCode = getAreaCode()

        const res = await saveProduct(this.addProductInfo)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存商品失败:', error)
        this.$message.error('保存商品失败')
      }
    },

    _initAddProduct() {
      // 初始化富文本编辑器
      // 这里需要根据实际使用的富文本编辑器组件进行调整
    },

    _openAddSpecModal() {
      const productSpec = {
        specCd: "0",
        stock: "0",
        sales: "0",
        price: "0.00",
        costPrice: "0.00",
        ownerPrice: "0.00",
        vipPrice: "0.00",
        otPrice: "0.00",
        deduction: "0.00",
        isDefault: "F",
        barCode: ""
      }

      this.addProductInfo.productSpecs.push(productSpec)

      // 如果没有默认规格，设置第一个为默认
      if (!this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addProductInfo.productSpecs.length > 0) {
        this.addProductInfo.productSpecs[0].isDefault = "T"
      }
    },

    _openAddDeleteProductSpec(productSpec) {
      const index = this.addProductInfo.productSpecs.indexOf(productSpec)
      if (index > -1) {
        this.addProductInfo.productSpecs.splice(index, 1)
      }

      // 如果没有默认规格，设置第一个为默认
      if (!this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addProductInfo.productSpecs.length > 0) {
        this.addProductInfo.productSpecs[0].isDefault = "T"
      }
    },

    _doAddDefaultProductSpec(product, defaultProductSpec) {
      product.productSpecs.forEach(item => {
        item.isDefault = "F"
      })
      defaultProductSpec.isDefault = "T"
      this.addProductInfo.productSpecs = JSON.parse(JSON.stringify(product.productSpecs))
    },

    _changeShopHouseAdd(shopHouseId) {
      const shopHouse = this.addProductInfo.shopHouses.find(item => item.shId === shopHouseId)
      if (shopHouse) {
        this.addProductInfo.shName = shopHouse.shName
      }
    },

    async _listAddHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 30,
          typeCd: '2002',
          shopId: '9999',
          skipType: '3'
        }
        const res = await queryHousekeepingType(params)
        this.addProductInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取家政类型失败:', error)
      }
    },

    async _listShopHouses() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.shopId
        }
        const res = await queryShopHouse(params)
        this.addProductInfo.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },

    async _listAddProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 5000,
          shopId: this.shopId,
          queryType: 'lever'
        }
        const res = await queryProductCategory(params)
        if (res.code === 0) {
          this.addProductInfo.productCategorys = res.data || []
        }
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },

    formatCategoryOptionLabel(category) {
      const level = Number(category.categoryLevel || 1)
      const prefix = level > 1 ? `${'　'.repeat(level - 1)}├─ ` : ''
      return `${prefix}${category.categoryName}`
    },

    _closeAddProduct() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #edf1f2;
  border-bottom: 1px solid #e7eaec;
  padding: 14px 15px 7px;
  min-height: 48px;
}


.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>